<div class="modal-header">
  <h5 class="modal-title d-flex gap-2 align-items-center">
    <i class="cs-icon cs-icon-calculator"></i> <ng-container i18n>Cost Estimator</ng-container>
    <app-page-help videoId="-" articleId="vkkuPYCUhvd5gwasjEWHzy"></app-page-help>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="fal fa-times"></i>
  </button>
</div>

<div class="modal-body bg-none p-0">
  <div class="row" [formGroup]="form">
    <div class="col-md-6">
      <app-rental-select i18n-placeholder [ctrl]="form.get('rentalId')" [multiple]="false" placeholder="Rental">
      </app-rental-select>
    </div>
    <div class="col-md-6">
      <app-select-search
        [items]="channels$ | async"
        [ctrl]="form.get('channelId')"
        [multiple]="false"
        bindValue="channelId"
        bindLabel="label"
        placeholder="Channel"
        i18n-placeholder
        [inline]="false"
      >
      </app-select-search>
    </div>

    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              [matDatepicker]="arriveDate"
              i18n-placeholder
              placeholder="Arrive"
              [max]="maxStartDate"
              [required]="true"
              (focus)="arriveDate.open()"
              formControlName="arrive"
              readonly
            />
            <i matSuffix (click)="arriveDate.open()" class="cs-icon cs-icon-calendar"></i>
            <mat-datepicker #arriveDate></mat-datepicker>
            <mat-error *ngIf="form.get('arrive').touched && form.get('arrive').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              [matDatepicker]="departDate"
              i18n-placeholder
              placeholder="Depart"
              [required]="true"
              [min]="minEndDate"
              (focus)="departDate.open()"
              formControlName="depart"
              readonly
            />
            <i matSuffix (click)="departDate.open()" class="cs-icon cs-icon-calendar"></i>
            <mat-datepicker #departDate></mat-datepicker>
            <mat-error *ngIf="form.get('depart').touched && form.get('depart').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              type="number"
              min="1"
              step="1"
              formControlName="adults"
              matInput
              required
              placeholder="Adults"
              i18n-placeholder
            />
            <mat-error *ngIf="form.get('adults').touched && form.get('adults').hasError('required')">
              <ng-container i18n>Adults field is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('adults').hasError('pattern')">
              <ng-container i18n>Adults field must be a whole number</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              type="number"
              min="0"
              step="1"
              formControlName="children"
              matInput
              i18n-placeholder
              placeholder="Children"
            />
            <mat-error *ngIf="form.get('children').touched && form.get('children').hasError('pattern')">
              <ng-container i18n>Children field must be a whole number</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <input type="number" [formControl]="baseChargeCtrl" matInput i18n-placeholder placeholder="Base Charge" />
      </mat-form-field2>
    </div>
    <div class="col-md-3">
      <app-select-search
        [items]="rateCategories"
        bindValue="id"
        bindLabel="name"
        [ctrl]="form.get('category')"
        [multiple]="false"
        placeholder="Rate Category"
        i18n-placeholder
        [inline]="false"
      >
      </app-select-search>
    </div>

    <div class="col-sm-3">
      <mat-form-field2 class="mat-block">
        <input
          type="text"
          [formControl]="form.get('discount_code')"
          matInput
          i18n-placeholder
          placeholder="Discount Code"
        />
      </mat-form-field2>
    </div>

    <div *ngIf="estimatedCost.value?.extraGuests as extraguests" class="col-sm-6">
      <app-form-input
        label="Additional Guests Fee"
        i18n-label
        [labelHint]="estimatedCost.value?.currency"
        [value]="extraguests"
        [disabled]="true"
      ></app-form-input>
    </div>

    <div *ngIf="estimatedCost.value?.auditDiscounts as auditDiscounts" class="col-sm-6">
      <div class="row" *ngFor="let item of auditDiscounts">
        <div class="col-md-12 discount-holder">
          <app-form-input
            label="{{ item.disc_type === 'lengthofstay' ? 'Los Discount' : 'Discount Code' }}"
            [labelHint]="estimatedCost.value?.currency"
            [value]="item.disc_amount"
            [disabled]="true"
          >
            <ng-container *ngIf="item.disc_type === 'lengthofstay'">
              <form-field-affix *fieldSuffix>
                <a (click)="onViewDiscount(item)" matTooltip="View Discount">
                  <i class="fas fa-eye"></i>
                </a>
              </form-field-affix>
            </ng-container>
          </app-form-input>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="estimatedCost.value?.taxes as taxes">
    <div *ngFor="let item of taxes">
      <div class="row">
        <div class="col-md-3">
          <app-form-input i18n-label label="Tax Name" [value]="item.name" [disabled]="true"></app-form-input>
        </div>
        <div class="col-md-3 pl-0">
          <app-form-input
            i18n-label
            label="Tax Rate"
            labelHint="{{ item.type === 'flat' ? estimatedCost.value?.currency : '%' }}"
            [value]="item.rate"
            [disabled]="true"
          ></app-form-input>
        </div>
        <div class="col-md-3 pl-0" [matTooltip]="modalityLabels[item.modality]">
          <app-form-input
            i18n-label
            label="Modality"
            [value]="modalityLabels[item.modality]"
            [disabled]="true"
          ></app-form-input>
        </div>
        <div class="col-md-3 pl-0">
          <app-form-input
            i18n-label
            label="Tax Amount"
            [labelHint]="estimatedCost.value?.currency"
            [value]="item.amount"
            [disabled]="true"
          >
          </app-form-input>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="estimatedCost.value?.bookingFees as fees">
    <div *ngFor="let item of fees">
      <div class="row">
        <div class="col-md-3">
          <app-form-input i18n-label label="Fee Name" [value]="item.name" [disabled]="true"></app-form-input>
        </div>
        <div class="col-md-3 pl-0">
          <app-form-input
            i18n-label
            label="Fee Rate"
            labelHint="{{ item.type === 'flat' ? estimatedCost.value?.currency : '%' }}"
            [value]="item.rate"
            [disabled]="true"
          ></app-form-input>
        </div>
        <div class="col-md-3 pl-0" [matTooltip]="modalityLabels[item.modality]">
          <app-form-input
            i18n-label
            label="Modality"
            [value]="modalityLabels[item.modality]"
            [disabled]="true"
          ></app-form-input>
        </div>
        <div class="col-md-3 pl-0">
          <app-form-input
            i18n-label
            label="Fee Amount"
            [labelHint]="estimatedCost.value?.currency"
            [value]="item.amount"
            [disabled]="true"
          >
          </app-form-input>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="potentialFees?.length">
    <h6>These booking fees may apply</h6>
    <div *ngFor="let item of potentialFees">
      <div class="row">
        <div class="col-md-3">
          <app-form-input i18n-label label="Fee Name" [value]="item.name" [disabled]="true"></app-form-input>
        </div>
        <div class="col-md-3 pl-0">
          <app-form-input
            label="Fee Rate"
            i18n-label
            labelHint="{{ item.type === 'flat' ? estimatedCost.value?.currency : '%' }}"
            [value]="item.amount"
            [disabled]="true"
          ></app-form-input>
        </div>
        <div class="col-md-3 pl-0" [matTooltip]="modalityLabels[item.modality]">
          <app-form-input
            i18n-label
            label="Modality"
            [value]="modalityLabels[item.modality]"
            [disabled]="true"
          ></app-form-input>
        </div>
        <div class="col-md-3 pl-0">
          <app-form-input
            i18n-label
            label="Fee Amount"
            labelHint="{{ item.type === 'flat' ? estimatedCost.value?.currency : '%' }}"
            [value]="item.amount"
            [disabled]="true"
          ></app-form-input>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer border-top">
  <div *ngIf="estimatedCost.value as cost" class="text-success text-xxxl">
    {{ cost.total | currency : ' ' : 'code' : '.0-2' }}
  </div>
  <div class="flex-fill"></div>

  <button type="button" class="btn btn-secondary-primary" (click)="close()">
    <ng-container i18n>Done</ng-container> <i class="fas fa-check"></i>
  </button>
</div>
